const config = {
  // 我的服务右侧内容配置
  productContent: {
    'tpc': {
      formal: [
        { key: 'titleConfigI18n.tpczs1', highlight: '更快速' },
        { key: 'titleConfigI18n.tpczs2', highlight: '更精准' },
        { key: 'titleConfigI18n.tpczs3', highlight: '范围三' },
        { key: 'titleConfigI18n.tpczs4', highlight: '定制化' },
        { key: 'titleConfigI18n.tpczs5', highlight: '无上限' },
        { key: 'titleConfigI18n.tpczs6', highlight: '多模态' },
        { key: 'titleConfigI18n.tpczs7', highlight: '高容错' }
      ],
      trial: [
        { key: 'titleConfigI18n.tpcty1', highlight: '范围一、二' },
        { key: 'titleConfigI18n.tpcty2', highlight: '1个' },
        { key: 'titleConfigI18n.tpcty3', highlight: '数量 ≤ 20' },
        { key: 'titleConfigI18n.tpcty4', highlight: '' },
        { key: 'titleConfigI18n.tpcty5', highlight: '3次' }
      ]
    },
    'tzj': {
      formal: [
        { key: 'titleConfigI18n.tzjzs1', highlight: 'AI实时' },
        { key: 'titleConfigI18n.tzjzs2', highlight: 'LCA方法学' },
        { key: 'titleConfigI18n.tzjzs3', highlight: '自动化' },
        { key: 'titleConfigI18n.tzjzs4', highlight: '定制化' },
        { key: 'titleConfigI18n.tzjzs5', highlight: '无上限' },
        { key: 'titleConfigI18n.tzjzs6', highlight: '多模态' },
        { key: 'titleConfigI18n.tzjzs7', highlight: '高容错' },
      ],
      trial: [
        { key: 'titleConfigI18n.tzjty1', highlight: '从摇篮到大门' },
        { key: 'titleConfigI18n.tzjty2', highlight: '1个' },
        { key: 'titleConfigI18n.tzjty3', highlight: '数量 ≤ 20' },
        { key: 'titleConfigI18n.tzjty4', highlight: '' },
        { key: 'titleConfigI18n.tzjty5', highlight: '3次' }
      ]
    },
    'esg': {
      formal: [
        'ESG指标 全覆盖',
        '自动生成 合规报告',
        '多维度 数据分析'
      ],
      trial: [
        '试用版仅支持部分ESG指标',
        '报告导出次数有限'
      ]
    }
  },
  // 我的服务右侧选择配置
  titleConfig: {
    'tpc': {
      formal: {
        main: 'titleConfigI18n.zs',
        switch: 'titleConfigI18n.ty'
      },
      trial: {
        main: 'titleConfigI18n.sy',
        switch: 'titleConfigI18n.gm'
      }
    },
    'tzj': {
      formal: {
        main: 'titleConfigI18n.zs',
        switch: 'titleConfigI18n.ty'
      },
      trial: {
        main: 'titleConfigI18n.sy',
        switch: 'titleConfigI18n.gm'
      }
    },
    'esg': {
      formal: {
        main: 'titleConfigI18n.zs',
        switch: 'titleConfigI18n.ty'
      },
      trial: {
        main: 'titleConfigI18n.sy',
        switch: 'titleConfigI18n.gm'
      }
    }
  },
  // 动态列配置
  dynamicColumns: {
    'tpc': [
      {
        prop: 'scope',
        label: 'serviceI18n.scope',
        renderKey: row => row.config.scope == 0 ? 'serviceI18n.scope_list[0].name' : 'serviceI18n.scope_list[1].name'
      },
      {
        prop: 'address_limit',
        label: 'serviceI18n.address_limit',
        render: row => row.config.address_limit == 2 && !row.order ? "≤2" : row.config.address_limit == 4 && !row.order ? "≤4" : row.config.address_limit == 30 && !row.order ? "≤30" : row.config.address_limit
      },
      {
        prop: 'source_limit',
        label: 'serviceI18n.source_limit',
        render: row => row.config.source_limit == 0 ? "≤100" : row.config.source_limit == 1 && !row.order ? "≤500" : row.config.source_limit == 1 && row.order ? "101-500" : row.config.source_limit == 2 && !row.order ? "≤1000" : row.config.source_limit == 2 && row.order ? ">500" : row.config.source_limit == 10 ? "≤20" : ""
      }
    ],
    'tzj': [
      {
        prop: 'source_limit',
        label: "原辅材料数量",
        render: row => row.config.source_limit == 0 ? "≤20" : row.config.source_limit == 1 ? ">20" : ""
      }
    ]
  },
  // 聊天界面介绍配置
  chatContentConfig: {
    tpcContent: 'chatPage.tpcContent',
    aiContent: 'chatPage.aiContent',
    tzjContent: "chatPage.tzjContent",
  },
  
  // Preview流程步骤配置
  stepListConfig: {
    tpc: [
      {
        id: '',
        conversation_id: '',
        stage_name: '材料',
        stage_code: 'material',
        stage_index: 1,
        stage_status: 0, // 0:未开始, 1:进行中, 2:已完成
        stageToListMapping: 'projectInfo',
        stageShowList: ['projectInfo', 'materialList']
      },
      {
        id: '',
        conversation_id: '',
        stage_name: '解析',
        stage_code: 'analysis',
        stage_index: 2,
        stage_status: 0,
        stageToListMapping: 'dataSummary',
        stageShowList: ['emissionSource', 'dataSummary']
      },
      {
        id: '',
        conversation_id: '',
        stage_name: '计算',
        stage_code: 'calculation',
        stage_index: 3,
        stage_status: 0,
        stageToListMapping: 'dataCalculate',
        stageShowList: ['dataCalculate']
      },
      {
        id: '',
        conversation_id: '',
        stage_name: '报告',
        stage_code: 'report',
        stage_index: 4,
        stage_status: 0,
        stageToListMapping: 'dataReport',
        stageShowList: ['dataReport']
      },
      {
        id: '',
        conversation_id: '',
        stage_name: '认证',
        stage_code: 'certification',
        stage_index: 5,
        stage_status: 0,
        stageToListMapping: 'verifyCertify',
        stageShowList: ['verifyCertify']
      },
    ],
    tzj: [
      {
        id: '',
        conversation_id: '',
        stage_name: '材料',
        stage_code: 'material',
        stage_index: 1,
        stage_status: 0,
        stageToListMapping: 'projectInfo',
        stageShowList: ['projectInfo', 'productOutput','materialList']
      },
      {
        id: '',
        conversation_id: '',
        stage_name: '解析',
        stage_code: 'analysis',
        stage_index: 2,
        stage_status: 0,
        stageToListMapping: 'dataSummary',
        stageShowList: ['emissionSource', 'dataSummary']
      },
      {
        id: '',
        conversation_id: '',
        stage_name: '计算',
        stage_code: 'calculation',
        stage_index: 3,
        stage_status: 0,
        stageToListMapping: 'dataCalculate',
        stageShowList: ['dataCalculate', 'dataQuality']
      },
      {
        id: '',
        conversation_id: '',
        stage_name: '报告',
        stage_code: 'report',
        stage_index: 4,
        stage_status: 0,
        stageToListMapping: 'dataReport',
        stageShowList: ['dataReport']
      },
      {
        id: '',
        conversation_id: '',
        stage_name: '认证',
        stage_code: 'certification',
        stage_index: 5,
        stage_status: 0,
        stageToListMapping: 'verifyCertify',
        stageShowList: ['verifyCertify']
      },
    ]
  },
  // Preview列表栏配置
  listBarConfig: {
    tpc: [
      {
        key: 'projectInfo',
        label: '项目基本信息',
        icon: 'list_1',
        component: 'ProjectInfo',
        order: 1,
        apiNodeCodeMap: 'project_info'
      },
      {
        key: 'materialList',
        label: '材料收集清单',
        icon: 'list_2',
        component: 'MaterialList',
        order: 2,
        apiNodeCodeMap: 'material_list'
      },
      {
        key: 'emissionSource',
        label: '排放源识别',
        icon: 'list_3',
        component: 'EmissionSource',
        order: 3,
        apiNodeCodeMap: 'emission_src_identify'
      },
      {
        key: 'dataSummary',
        label: '活动数据汇总',
        icon: 'list_4',
        component: 'DataSummary',
        order: 4,
        apiNodeCodeMap: 'emission_src_total'
      },
      {
        key: 'dataCalculate',
        label: '碳盘查计算',
        icon: 'list_5',
        component: 'DataCalculate',
        order: 5,
        apiNodeCodeMap: 'emission_src_calc'
      },
      {
        key: 'dataReport',
        label: '碳盘查报告',
        icon: 'list_6',
        component: 'DataReport',
        order: 6,
        apiNodeCodeMap: 'tpc_report'
      },
      {
        key: 'verifyCertify',
        label: '核查认证',
        icon: 'list_7',
        component: 'VerifyCertify',
        order: 7,
        apiNodeCodeMap: 'audit_certification'
      }
    ],
    tzj: [
      {
        key: 'projectInfo',
        label: '项目基本信息',
        icon: 'list_1',
        component: 'ProjectInfo',
        order: 1,
        apiNodeCodeMap: 'project_info'
      },
      {
        key: 'productOutput',
        label: '产品产量表',
        icon: 'list_8',
        component: 'ProductOutput',
        order: 2,
        apiNodeCodeMap: 'product_output'
      },
      {
        key: 'materialList',
        label: '材料收集清单',
        icon: 'list_2',
        component: 'MaterialList',
        order: 3,
        apiNodeCodeMap: 'material_list'
      },
      {
        key: 'emissionSource',
        label: '排放源识别',
        icon: 'list_3',
        component: 'EmissionSource',
        order: 4,
        apiNodeCodeMap: 'emission_src_identify'
      },
      {
        key: 'dataSummary',
        label: '活动数据汇总',
        icon: 'list_4',
        component: 'DataSummary',
        order: 5,
        apiNodeCodeMap: 'emission_src_total'
      },
      {
        key: 'dataCalculate',
        label: '排放量计算',
        icon: 'list_5',
        component: 'DataCalculate',
        order: 6,
        apiNodeCodeMap: 'emission_src_calc'
      },
      {
        key: 'dataQuality',
        label: '数据质量评价',
        icon: 'list_9',
        component: 'DataQuality',
        order: 7,
        apiNodeCodeMap: 'data_quality_eval'
      },
      {
        key: 'dataReport',
        label: '碳足迹报告',
        icon: 'list_6',
        component: 'DataReport',
        order: 8,
        apiNodeCodeMap: 'tzj_report'
      },
      {
        key: 'verifyCertify',
        label: '核查认证',
        icon: 'list_7',
        component: 'VerifyCertify',
        order: 9,
        apiNodeCodeMap: 'audit_certification'
      }
    ]
  }
};

export default config;

